export default __webpack_public_path__ + "static/media/placeholder_business04-en-mobile.4fe59216.png";